import { styled, Typography } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

export const Root = styled('div', { shouldForwardProp: shouldForwardProp() })<{ isSmsEnabled?: boolean | undefined }>(
  ({ theme, isSmsEnabled = false }) => ({
    overflow: 'hidden',
    height: isSmsEnabled ? 333 : 273,
    [theme.breakpoints.up('sm')]: {
      boxSizing: 'border-box',
      padding: theme.spacing(0, 2),
      width: 360,
      height: isSmsEnabled ? 345 : 285,
    },
  }),
);

export const Header = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(4),
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  height: 40,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
}));
